var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _g2, _path9, _path10, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5467 0.826619L46.2984 4.26848C47.5476 4.73212 48.6161 5.55507 49.4515 6.62314L58.9832 18.2148C60.2256 19.7182 60.9184 21.6809 60.8523 23.6462L60.3833 41.7594C60.3434 43.7818 59.5492 45.6664 58.1815 47.0538L49.39 56.0614C48.5147 57.0157 47.3681 57.6798 46.1476 58.0322L36.0413 61.0088L35.5467 0.826619Z",
    fill: "url(#paint0_linear_7_4819)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0889 0.77139L18.5369 2.35057C16.9095 2.2677 15.3417 2.91762 14.2333 4.11703L3.33958 17.1294C2.37625 18.1932 1.7937 19.6352 1.77265 21.096L1.45309 37.2749C1.43204 38.7358 1.9725 40.2155 2.91734 41.3716L13.3445 56.4225C14.425 57.7237 15.9456 58.4775 17.6301 58.5342L34.2069 61.2281C35.8343 61.311 37.4021 60.6611 38.5105 59.4617L51.2789 45.8659C52.2422 44.8021 52.851 43.4173 52.8458 41.8993L53.1667 21.5044C53.1878 20.0435 52.6473 18.5637 51.7025 17.4077L39.3744 2.8831C38.2677 1.52483 36.7472 0.770977 35.0889 0.77139Z",
    fill: "url(#paint1_linear_7_4819)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8121 7.9409L19.5736 9.13118C18.3673 9.06248 17.2254 9.5862 16.381 10.4572L8.35107 20.2212C7.62085 21.0399 7.19284 22.0654 7.15506 23.1884L6.88921 35.2655C6.85142 36.3885 7.26567 37.4424 7.93921 38.3083L15.6293 49.5007C16.4123 50.4546 17.5735 51.0277 18.7536 51.0393L30.9977 53.0253C32.204 53.094 33.3459 52.5703 34.1903 51.6993L43.6381 41.5614C44.3684 40.7427 44.7964 39.7172 44.8342 38.5942L45.0945 23.3408C45.1323 22.2178 44.718 21.1639 44.0445 20.298L34.9364 9.47948C34.1225 8.60888 33.0184 8.0096 31.8121 7.9409Z",
    fill: "#F08F3B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_4819",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 7,
    width: 40,
    height: 47
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8121 7.9409L19.5736 9.13118C18.3673 9.06248 17.2254 9.5862 16.381 10.4572L8.35107 20.2212C7.62085 21.0399 7.19284 22.0654 7.15506 23.1884L6.88921 35.2655C6.85142 36.3885 7.26567 37.4424 7.93921 38.3083L15.6293 49.5007C16.4123 50.4546 17.5735 51.0277 18.7536 51.0393L30.9977 53.0253C32.204 53.094 33.3459 52.5703 34.1903 51.6993L43.6381 41.5614C44.3684 40.7427 44.7964 39.7172 44.8342 38.5942L45.0945 23.3408C45.1323 22.2178 44.718 21.1639 44.0445 20.298L34.9364 9.47948C34.1225 8.60888 33.0184 8.0096 31.8121 7.9409Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_4819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0979 8.02337L22.8593 9.21367C21.6531 9.14497 20.5112 9.66869 19.6667 10.5397L11.6369 20.3037C10.9066 21.1224 10.4786 22.1479 10.4408 23.2709L10.175 35.348C10.1372 36.471 10.5514 37.5249 11.225 38.3908L18.9151 49.5832C19.6981 50.5371 20.8593 51.1102 22.0394 51.1218L34.2835 53.1078C35.4898 53.1765 36.6317 52.6528 37.4761 51.7818L46.9239 41.6439C47.6541 40.8252 48.0822 39.7997 48.1199 38.6767L48.3802 23.4233C48.418 22.3003 48.0038 21.2464 47.3302 20.3805L38.2222 9.56197C37.4392 8.60809 36.3042 8.09207 35.0979 8.02337Z",
    fill: "#FFA42F"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.782 44.0464L25.1165 44.8731L32.4662 16.9009L38.7294 21.2153C39.2244 21.5412 39.6313 21.9765 39.8932 22.5474C40.5526 23.8344 41.2218 26.499 39.6669 30.9438C38.6112 33.9157 35.8191 38.3751 33.443 41.3307C32.6462 42.4563 31.0549 43.8081 29.782 44.0464Z",
    fill: "#F08F3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7187 19.6315C23.5027 13.4794 35.0784 16.1175 37.5351 21.6248C40.9037 29.2709 30.1344 45.2668 24.6954 44.8589C20.3223 44.515 10.0226 25.674 16.7187 19.6315Z",
    fill: "url(#paint2_linear_7_4819)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9104 24.1797C19.1634 24.6605 18.6616 25.3744 18.607 26.1596C18.5122 27.3088 18.7886 29.1169 20.7878 31.5171C24.2744 35.6537 25.6576 29.6291 25.2764 27.5926C24.6261 24.3665 22.6651 22.5017 19.9104 24.1797Z",
    fill: "#E17E3B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7_4819",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 23,
    width: 8,
    height: 10
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9104 24.1797C19.1634 24.6605 18.6616 25.3744 18.607 26.1596C18.5122 27.3088 18.7886 29.1169 20.7878 31.5171C24.2744 35.6537 25.6576 29.6291 25.2764 27.5926C24.6261 24.3665 22.6651 22.5017 19.9104 24.1797Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7_4819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1287 24.7267C20.3818 25.2075 19.8799 25.9214 19.8254 26.7066C19.7305 27.8557 20.007 29.6639 22.0061 32.0641C25.4927 36.2007 26.8759 30.1761 26.4948 28.1396C25.8182 24.8564 23.9406 23.0225 21.1287 24.7267Z",
    fill: "#F8902C"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9882 26.3174C35.5381 27.5164 35.4908 28.9202 34.6679 29.9887C33.9639 30.8644 32.834 31.8664 30.7214 32.8352C25.1832 35.3753 26.9803 28.7463 28.4192 26.9115C30.6812 24.0083 33.4123 23.0321 34.9882 26.3174Z",
    fill: "#E27A36"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7_4819",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 24,
    width: 10,
    height: 10
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9882 26.3174C35.5381 27.5164 35.4908 28.9202 34.6679 29.9887C33.9639 30.8644 32.834 31.8664 30.7214 32.8352C25.1832 35.3753 26.9803 28.7463 28.4192 26.9115C30.6812 24.0083 33.4123 23.0321 34.9882 26.3174Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7_4819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9781 26.9691C36.528 28.1681 36.4808 29.5718 35.6578 30.6403C34.9538 31.5161 33.8239 32.518 31.7114 33.4869C26.1731 36.0269 27.9702 29.3979 29.4092 27.5631C31.6711 24.6599 34.3451 23.7099 35.9781 26.9691Z",
    fill: "#F8902C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_4819",
    x1: 45.4121,
    y1: 47.0475,
    x2: 49.9269,
    y2: 11.6418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0196,
    stopColor: "#E48818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4383,
    stopColor: "#E48A19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5891,
    stopColor: "#E6911E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6966,
    stopColor: "#E99C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#ECAD34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8296,
    stopColor: "#EFBA3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#EEB839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8845,
    stopColor: "#ECB632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBB530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_4819",
    x1: 12.0048,
    y1: 56.3498,
    x2: 40.6543,
    y2: 9.70896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0196,
    stopColor: "#FFBF20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#FABF36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7859,
    stopColor: "#FAD64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAE95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_4819",
    x1: 16.0912,
    y1: 33.2535,
    x2: 38.9153,
    y2: 25.8277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0196,
    stopColor: "#FACA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3908,
    stopColor: "#FACD4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#FAD855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAE95F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.ce899ddd6da8c4ef838c69acd457495f.svg";
export { ForwardRef as ReactComponent };